// Generated by packages/ui/scripts/build-app-sprite.mjs - do not edit manually
export const spriteUrl = '/forms/sprite.aaf9cffc0b17.svg' as const;
